class CollectionLoadMore{

    constructor() {
        console.log('CollectionLoadMore initializing...');
        this.buttonSelector = '[data-collection-load-more-btn]';
        this.buttonLoadingClassName = 'loading';
        this.productsWrapperSelector = '[data-collection-products-wrapper]';

        this.instantiated = false;

        this.$btn = jQuery(this.buttonSelector);
        this.$wrapper = jQuery(this.productsWrapperSelector);


        if(this.$btn.length < 1 || this.$wrapper.length < 1){
            return;
        }

        this.initEvents();
        console.log('CollectionLoadMore instantiated');
        this.instantiated = true;

    }

    initEvents(){
        this.$btn.on('click', this.handleClick.bind(this));
    }

    handleClick(event){
        event.preventDefault();
        this.loadMore();
    }

    getNextUrl($el){
        return $el.attr('href');
    }

    disableButton(){
        this.$btn.prop('disabled',  true);
        this.$btn.addClass('disabled');
    }

    loadMore(){

        if(this.$btn.hasClass(this.buttonLoadingClassName)){
            return;
        }

        let nextUrl = this.getNextUrl(this.$btn);

        if(!(nextUrl)){
           this.disableButton();
        }

        // Make ajax call to next page for load more data
        jQuery.ajax({
            url: nextUrl,
            type: 'GET',
            context: this,
            beforeSend: ()=>{
                this.$btn.addClass(this.buttonLoadingClassName );
            }
        })
            .done((data)=> {

                // Append data
                const $newPage = jQuery(data);
                const $newItems = $newPage.find(this.productsWrapperSelector).children();
                const $newNextBtn = $newPage.find(this.buttonSelector);
                const newNextURL = this.getNextUrl($newNextBtn);

                this.$wrapper.append($newItems);

                this.$btn.removeClass(this.buttonLoadingClassName );

                if($newNextBtn.length < 1 || !(newNextURL)){
                    this.disableButton();
                }else{
                    this.$btn.attr('href', newNextURL);
                }

            });
    }

    static instantiate(){
        window.WPShopify = window.WPShopify || {};
        window.WPShopify.CollectionLoadMore = new CollectionLoadMore();
    }
}

CollectionLoadMore.instantiate();